module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main",
    class: {
      'main-hide-text': _vm.hideMenuText
    },
    attrs: {
      "id": "main"
    }
  }, [_c('div', {
    staticClass: "sidebar-menu-con",
    staticStyle: {
      "display": "flex",
      "height": "100%"
    }
  }, [_c('sidebar-menu', {
    attrs: {
      "hideMenuText": _vm.hideMenuText,
      "menuList": _vm.menuList,
      "iconSize": 18
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "main-header-con",
    style: ({
      paddingLeft: _vm.hideMenuText ? '50px' : '210px'
    })
  }, [_c('div', {
    staticClass: "main-header",
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_c('div', {
    staticClass: "navicon-con"
  }, [_c('Button', {
    style: ({
      transform: 'rotateZ(' + (this.hideMenuText ? '-90' : '0') + 'deg)'
    }),
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.toggleClick
    }
  }, [_c('Icon', {
    attrs: {
      "type": "md-menu",
      "size": "26"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "header-middle-con"
  }, [_c('div', {
    staticClass: "main-breadcrumb"
  }, [_c('breadcrumb-nav', {
    staticStyle: {
      "color": "#fff"
    },
    attrs: {
      "currentPath": _vm.currentPath
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "header-avator-con"
  }, [_c('div', {
    staticClass: "user-dropdown-menu-con"
  }, [_c('Row', {
    staticClass: "user-dropdown-innercon",
    attrs: {
      "type": "flex",
      "justify": "end",
      "align": "middle"
    }
  }, [_c('Dropdown', {
    attrs: {
      "trigger": "click"
    },
    on: {
      "on-click": _vm.handleClickUserDropdown
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_c('span', {
    staticClass: "main-user-name",
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v(_vm._s(_vm.display))]), _vm._v(" "), _c('Icon', {
    attrs: {
      "type": "md-arrow-dropdown"
    }
  })], 1), _vm._v(" "), _c('DropdownMenu', {
    attrs: {
      "slot": "list"
    },
    slot: "list"
  }, [_c('DropdownItem', {
    attrs: {
      "name": "loginout"
    }
  }, [_vm._v("退出登录")])], 1)], 1), _vm._v(" "), _c('Avatar', {
    staticStyle: {
      "background": "#ffffff",
      "margin-left": "10px"
    },
    attrs: {
      "src": _vm.avatorPath
    }
  })], 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "single-page-con",
    style: ({
      paddingLeft: _vm.hideMenuText ? '60px' : '200px'
    })
  }, [_c('div', {
    staticClass: "single-page"
  }, [_c('keep-alive', [(_vm.$route.meta.keepAlive) ? _c('router-view', {
    key: _vm.key
  }) : _vm._e()], 1), _vm._v(" "), (!_vm.$route.meta.keepAlive) ? _c('router-view') : _vm._e()], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e2e2134","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/main.vue
// module id = 468
// module chunks = 99